/* 落地页的一些通用组件，如果是全站都用的，写入 lepro-common.js 中 */

// 底部悬浮购物车信息
class LeproFixedCartPage extends HTMLElement {
    elements = this.getElements()

    constructor() {
      super();
  
      this.bindClick()
    }

    getElements() {
        return {
            cartDrawer: document.querySelector('cart-drawer'),
            viewCartBtn: this.querySelector('[data-view-btn]'),
            checkoutBtn: this.querySelector('[data-checkout-btn]')
        }
    }
  
    bindClick() {
        if (this.elements.viewCartBtn) {
            this.elements.viewCartBtn.addEventListener('click', () => {
                this.elements.cartDrawer.open()
            })
        }
        if (this.elements.checkoutBtn) {
            this.elements.checkoutBtn.addEventListener('click', () => {
                window.ShopifyConstant.linkCheckoutPage()
            })
        }
    }
  }
  customElements.define('lepro-fixed-cart-page', LeproFixedCartPage);